import React,{Component} from 'react';
import _ from 'lodash';
import PedidoDetalle from './PedidoDetalle';

const TablaTd = rows => rows.row.detalle===null || rows.row.detalle===undefined?[]:rows.row.detalle.map((row, i) =>
  <td key={i}>{row.desColorFabricaVeh}</td>
);

const TablaTr = (props) => {
  const pedidos = props.pedidos;
  if (_.isArray(pedidos)) {
    return pedidos.map(row =>
      <tr key={row.numPedidoVeh}>
        <td>
          <div className='checkbox checkbox-inline'>
            <label htmlFor={`${row.numPedidoVeh}-usocolor`}>
              <input
                type='checkbox'
                checked={props.pedidosConCheck.indexOf(row.numPedidoVeh)>=0}
                onChange={() => props.selectCheckPedidos(row.numPedidoVeh)}
                id={`${row.numPedidoVeh}-usocolor`}
              />
              <div className='checkbox-skin' />
            </label>
          </div>
        </td>
        <td><button className='btn btn-iconLeft btn-link' data-dismiss='modal' data-toggle='modal' data-target='#fdv-detalle'  onClick={() => props.fnSelectPedido(row.numPedidoVeh)} ><i/><span>{row.numPedidoVeh}</span></button></td>
        <td>{row.numChasis}</td>
        <td>{row.desUsoVeh}</td>
        {
          <TablaTd row={row} />
        }
      </tr>
    );
  }
  return null;
};

const TablaTh = (props) => {
  const pedidos = props.pedidos;
  if (_.isArray(pedidos)) {
    return _.times(_.max(pedidos.map(x =>  x.detalle ===null || x.detalle ===undefined ?0:x.detalle.length)), String).map((row, i) =>
      <th key={i}>
        {`COLOR ${i + 1}`}
      </th>
    );
  }
  return null;
};

class TablaUsoColor extends Component {

  constructor(props){
    super(props);

    this.state ={
      isOpen:false,
      selectPedido:''
     }
  }

  closeModal = () =>{
    this.setState({isOpen:false});
  }

  openModal = () =>{
    this.setState({isOpen:true});
  }

  fnSelectPedido = (selectPedido) => {
    this.setState({selectPedido:selectPedido,isOpen:true})

  }

  render() {
    return (
      <div>
        {
          this.props.pedidos.length>0 ?(
            <table className={'table table-hover'}>
              <thead className='table-head'>
                <tr>
                  <th>
                    <div className='checkbox checkbox-inline'>
                      <label>
                      <input type='checkbox' id={'checkBoxAll'} onClick={() => this.props.selectAll()} />
                        <div className='checkbox-skin' />
                      </label>
                    </div>
                  </th>
                  <th>Nº Pedido</th>
                  <th>Nº Chasis</th>
                  <th>Uso</th>
                  <TablaTh pedidos={this.props.pedidos} />
                </tr>
              </thead>
              <tbody>
                <TablaTr
                  pedidos={this.props.pedidos}
                  selectCheckPedidos={this.props.selectCheckPedidos}
                  pedidosConCheck={this.props.pedidosConCheck}
                  fnSelectPedido = {this.fnSelectPedido}
                />
              </tbody>
            </table>
          ): (
            <table className={'table table-hover'}>
              <thead className='table-head'>
                <tr>
                  <th>
                    <div className='checkbox checkbox-inline'>
                      <label>
                        <input type='checkbox' />
                        <div className='checkbox-skin' />
                      </label>
                    </div>
                  </th>
                  <th>Nº Pedido</th>
                  <th>Nº Chasis</th>
                  <th>Uso</th>
                </tr>
              </thead>
              <tbody>
                <tr >
                  <td colSpan='4'><p style={{'text-align':'center'}}> No existe registros !!</p> </td>
                </tr>
              </tbody>
            </table>
          )
        }

        {
          this.state.isOpen === true &&
          <PedidoDetalle
              isOpen={this.state.isOpen}
              closeModal = {this.closeModal}
              pedidos={this.props.pedidos.length > 0? this.props.pedidos.filter(entry => entry.numPedidoVeh===this.state.selectPedido)[0] : {}}
          />
        }
      </div>
    )
  }

}

TablaUsoColor.defaultProps = {
  pedidos: [],
};

export default TablaUsoColor;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/TablaUsoColor.js